// Utility functions to generate filter options for period, week, and action/status
// These can be imported and used in any module

/**
 * Returns year options for dropdowns
 * Fixed start year: 2024, up to current year
 */
export function getYearOptions() {
  const startYear = 2024;
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + 1; // Include one year in the future
  
  return Array.from({ length: endYear - startYear + 1 }, (_, i) => ({
    id: String(startYear + i),
    displayText: String(startYear + i),
  }));
}

/**
 * Returns period options for dropdowns (1-12 + 'All')
 */
export function getPeriodOptions() {
  return [
    // { id: "", displayText: "All" },
    ...Array.from({ length: 13 }, (_, i) => ({
      id: String(i + 1),
      displayText: String(i + 1),
    })),
  ];
}

/**
 * Returns week options for dropdowns (1-4)
 */
export function getWeekOptions() {
  return Array.from({ length: 4 }, (_, i) => ({
    id: String(i + 1),
    displayText: String(i + 1),
  }));
}

/**
 * Get current period, week, and year based on current date
 * This is a simplified calculation - adjust based on your business logic
 */
export function getCurrentPeriodWeekYear() {
  const now = new Date();
  const currentYear = now.getFullYear();
  
  // Calculate current period (1-12 based on month)
  const currentMonth = now.getMonth() + 1; // 1-12
  const currentPeriod = currentMonth;
  
  // Calculate current week (1-4 based on week of month)
  const firstDayOfMonth = new Date(currentYear, now.getMonth(), 1);
  const dayOfMonth = now.getDate();
  const dayOfWeek = firstDayOfMonth.getDay();
  const currentWeek = Math.ceil((dayOfMonth + dayOfWeek) / 7);
  
  return {
    period: Math.min(currentPeriod, 12),
    week: Math.min(currentWeek, 4),
    year: currentYear,
  };
}

/**
 * Given a current period/week, returns the previous period/week.
 * Week 1 rolls back to week 4 of the previous period; period 1 wraps to period 13.
 */
export function getPreviousPeriodAndWeek(currentPeriod: any, currentWeek: any) {
  const periodNum = Number(currentPeriod);
  const weekNum = Number(currentWeek);

  if (weekNum > 1) {
    return {
      period: String(periodNum),
      week: String(weekNum - 1),
    };
  }

  const prevPeriod = periodNum > 1 ? periodNum - 1 : 13;
  return {
    period: String(prevPeriod),
    week: "4",
  };
}

export function getActionOptions(
  data: Array<{
    Status: string | undefined;
    status?: string;
  }>
) {
  const actions = Array.from(
    new Set(
      (data || []).map((item) => item.status || item.Status).filter(Boolean)
    )
  );
  return actions.map((status) => ({ id: status, displayText: status }));
}

